export function filterBy(option, label, search) {
    label = label || "";
    label = label.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    search = search.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    return label.indexOf(search) > -1;
}